

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import pregunta from './resumen-preguntas-ml-pregunta.vue';
    import contestar from './resumen-preguntas-ml-contestar.vue';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta,
            contestar
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Preguntas: Pregunta[];
        public Seleccionada: Pregunta = null;


        Responder(x: Pregunta)
        {
            if ( x && x instanceof Pregunta )
            {
                this.Seleccionada = x;
            }
        }

        CancelarRespuesta( )
        {
                this.Seleccionada = null;
        }
    }
